import { DSToast } from 'designSystem';
import { DSToastType } from 'designSystem/DSToast';
import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isMobile } from 'shared/util/utility';

const Notification: React.FC = () => {
	return (
		<ToastContainer
			position={`${isMobile() ? 'top-center' : 'top-right'}`}
			autoClose={4000}
			newestOnTop={false}
			rtl={false}
			closeOnClick
			hideProgressBar
			limit={1}
			pauseOnHover
			draggable
			draggablePercent={40}
		/>
	);
};

let id = '';
export const addNotification = (type: DSToastType, message: string) => {
	if (id === '') {
		id = `${Math.random()}`;
		toast(
			<DSToast
				type={type}
				onClose={() => {
					id = '';
				}}
				cyTestRef="alert-message"
			>
				{message}
			</DSToast>,
			{
				toastId: id,
				onClose: () => {
					id = '';
				},
			},
		);
	} else {
		toast.update(id, {
			render: (
				<DSToast type={type} onClose={() => {}} cyTestRef="alert-message">
					{message}
				</DSToast>
			),
		});
	}
};

export default Notification;
